import React, { PropTypes } from 'react';
import ScreenHeader from '../Subcomponents/ScreenHeader';
import ScreenInstructions from '../Subcomponents/ScreenInstructions';
import ScreenContainer from '../Subcomponents/ScreenContainer';
import ActionButton from '../Subcomponents/ActionButton';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getScreen, cancel } from '../../../actions/screenAction';
import Popup from '../Subcomponents/Popup';

class Success extends React.Component {
  constructor(props) {
    super(props);
    this.getNextScreen = this.getNextScreen.bind(this);
    this.cancel = this.cancel.bind(this);
    this.showTsAndCs = this.showTsAndCs.bind(this);
    this.checkboxClicked = this.checkboxClicked.bind(this);

    this.state = {
      tsAndCsHidden: true,
      tsAndCsAccepted: false
    }
  }
  componentWillReceiveProps(newProps) {
    this.setState({ tsAndCsAccepted: false });
  }

  showTsAndCs(event, currentTsAndCs) {
    event.preventDefault();
    this.setState({ tsAndCsHidden: false,currentTsAndCs });
  }

  checkboxClicked(event) {
    this.setState({ tsAndCsAccepted: event.target.checked });
  }

  getNextScreen() {
    let currentState = {
      Values: { ButtonClicked: true, tsAndCsAccepted: this.state.tsAndCsAccepted }
    };
    this.props.actions.getScreen(currentState, this.props.name);
  }

  cancel(event) {
    event.preventDefault();
    this.props.actions.cancel(this.props.name);
  }

  render() {
    let textResources = this.props.textResources;
    let uiSpec = this.props.uiSpec;
    let values = this.props.values;
    let tsAndCs = [{Name: textResources.DocumentName, Text: textResources.DocumentText}];
    if(uiSpec && uiSpec.TermsAndConditionsLinks){
      const TermsAndConditionsLinks = JSON.parse(uiSpec.TermsAndConditionsLinks);
      if(TermsAndConditionsLinks.length){
        TermsAndConditionsLinks.map((t, i) => {
          tsAndCs[i] = {
            Key: i,
            Name: t.Name,
            Text: '<iframe src="'+t.Link+'" style="border: 0; width: 100%;height: 100%;"/>'
          };
        });
      }
    }
    const displayCheckbox = !(uiSpec.HideCheckbox == 'True');
    let currentTsAndCs = "";
    return (
      <ScreenContainer>
        <ScreenHeader title={textResources.HeaderTitle} text={textResources.HeaderText} icon="tick-in-circle.png" iconIsCircle="true" />
        <ScreenInstructions title={textResources.InstructionTitle} text={textResources.InstructionText} />
        <div className="o-pageSection o-pageSection--form">
          { 
            tsAndCs.map(
              tAndC => (
                <div key={tAndC.Key} className="c-TermsConditionsBox">
                  {displayCheckbox && 
                  <span className="c-TermsConditionsBox-checkbox">
                    <input type="checkbox" name="terms" id="terms" onClick={this.checkboxClicked} checked={this.state.tsAndCsAccepted} />
                  </span>}
                  <span className="c-TermsConditionsBox-text">
                    <label htmlFor="terms">{textResources.IAgree} <a href="#" onClick={(e)=>{this.showTsAndCs(e, tAndC.Text);}} className="u-underline">{tAndC.Name}.</a></label>
                  </span>
                </div>   
                )           
            )
          }
          <div className="pf-button-container">
            <ActionButton className="c-Btn c-Btn--primary u-mb6" valid={this.state.tsAndCsAccepted} action={this.getNextScreen} text={textResources.ContinueButtonText}></ActionButton>
            <a href="#" className="c-CancelLink" onClick={this.cancel}>{textResources.Cancel}</a>
          </div>
        </div>
        <Popup title={textResources.DocumentTitle} text={this.state.currentTsAndCs} hidden={this.state.tsAndCsHidden} closeButtonText={textResources.Back} hide={() => this.setState({ tsAndCsHidden: true })} />
      </ScreenContainer>
    );
  }
}



Success.propTypes = {
  name: React.PropTypes.string.isRequired,
  values: React.PropTypes.object.isRequired,
  uiSpec: React.PropTypes.object.isRequired,
  textResources: React.PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ getScreen, cancel }, dispatch)
  };
}

function mapStateToProps(state, ownProps) {
  return {
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Success);


/** WEBPACK FOOTER **
 ** ./src/components/ScreenComponents/Shared/Confirm.js
 **/